// Override Settings
if(typeof boostPFSThemeConfig !== 'undefined') {
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      /* Optional */
      loadProductFirst: true,
      refineByStyle: 'style2',
      filterTreeMobileIcon: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-filter" viewBox="0 0 64 64"><path d="M48 42h10M48 42a5 5 0 1 1-5-5 5 5 0 0 1 5 5zM7 42h31M16 22H6M16 22a5 5 0 1 1 5 5 5 5 0 0 1-5-5zM57 22H26"></path></svg>',
      separateRefineByFromFilter: true,
      collapseOnMobileByDefault: true,
    },
    selector: {
      avoidStickyHeader: '.site-header, .site-header--opening, #shopify-section-header',
      endStickyMobile: 'body'
    }
  };
}

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;
(function() {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  if (Utils.isMobile()) boostPFSFilterConfig.general.separateRefineByFromFilter = false;

  /************************** BUILD PRODUCT LIST **************************/

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function(data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;


    var productUrl = Utils.buildProductItemUrlWithVariant(data);
    var baseProductUrl = Utils.buildProductItemUrl(data, false);
    var trackPosition = index + 1;
    var trackTitle = String(data.title || '').replace(/"/g, '&quot;');

    var productTrackingAttr =
      ' data-track-click' +
      ' data-track-type="product"' +
      ' data-track-section="product_card"' +
      ' data-track-name="' + trackTitle + '"' +
      ' data-track-position="' + trackPosition + '"' +
      ' data-track-url="' + productUrl + '"' +
      ' data-track-product-id="' + data.id + '"' +
      ' data-track-product-title="' + trackTitle + '"' +
      ' data-track-product-handle="' + data.handle + '"';

      itemHtml = itemHtml.replace(
        /<a([^>]*href="{{itemUrl}}"[^>]*)>/,
        '<a$1' + productTrackingAttr + '>'
      );


    var quickViewTrackingAttr =
      ' data-track-click' +
      ' data-track-type="cta"' +
      ' data-track-section="product_card"' +
      ' data-track-name="quick_view"' +
      ' data-track-position="' + trackPosition + '"' +
      ' data-track-url="' + productUrl + '"' +
      ' data-track-product-id="' + data.id + '"' +
      ' data-track-product-title="' + trackTitle + '"' +
      ' data-track-product-handle="' + data.handle + '"';

    var wishlistTrackingAttr =
      ' data-track-click' +
      ' data-track-type="cta"' +
      ' data-track-section="product_card"' +
      ' data-track-name="wishlist"' +
      ' data-track-position="' + trackPosition + '"' +
      ' data-track-url="' + baseProductUrl + '"' +
      ' data-track-product-id="' + data.id + '"' +
      ' data-track-product-title="' + trackTitle + '"' +
      ' data-track-product-handle="' + data.handle + '"';

    itemHtml = itemHtml.replace(/{{grid_item_width}}/g, boostPFSConfig.custom.grid_item_width);
    itemHtml = itemHtml.replace(/{{products_per_row}}/g, boostPFSConfig.custom.products_per_row);



    // Add Thumbnail
    var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : '';
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : '100';
    var thumb = images.length > 0 ? images[0] : boostPFSConfig.general.no_image_url;
    var productGridImageFillClass = '';
    if(boostPFSConfig.custom.hasOwnProperty('product_grid_image_fill') && boostPFSConfig.custom.product_grid_image_fill){
      productGridImageFillClass = 'grid__image-contain';
    }
    var itemImagesHtml = '';
    if (boostPFSConfig.custom.product_grid_image_size == 'natural') {
      itemImagesHtml += '<div class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">';
      itemImagesHtml += '<img ' +
                  'class="grid-product__image lazyload" ' +
                  'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
                  'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                  'data-aspectratio="' + aspectRatio + '" ' +
                  'data-sizes="auto" ' +
                  'alt="{{itemTitle}}">';
      itemImagesHtml += '<noscript>' +
                '<img class="grid-product__image lazyloaded" ' +
                'src="' + Utils.getFeaturedImage(images, '400x') + '" ' +
                'alt="{{itemTitle}">' +
              '</noscript>';
      itemImagesHtml += '</div>';

    } else {
      itemImagesHtml += '<div class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + '" >';
      itemImagesHtml += '<img ' +
        'class="lazyload ' + productGridImageFillClass + '" ' +
        'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
        'data-widths="[360, 540, 720, 900, 1080]" ' +
        'data-aspectratio="' + aspectRatio + '" ' +
        'data-sizes="auto" ' +
        'alt="{{itemTitle}}">';
      itemImagesHtml += '</div>';
    }

    if (!soldOut) {
      if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
        itemImagesHtml += '<div class="grid-product__secondary-image small--hide">';
        itemImagesHtml += '<img class="lazyload"' +
          'data-src="' + Utils.optimizeImage(images[1].src, '{width}x') + '"' +
          'data-widths="[360, 540, 720, 900, 1080]"' +
          'data-aspectratio="' + aspectRatio + '"' +
          'data-sizes="auto"' +
          'alt="{{itemTitle}}">';
        itemImagesHtml += '</div>';
      }
    }

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Price
    var itemPriceHtml = '';
    if (priceVaries) {
      itemPriceHtml += boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min));
    } else {
      itemPriceHtml += Utils.formatMoney(data.price_min);
    }
    if (onSale) {
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
      itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
    }
    if (onSale && boostPFSConfig.custom.product_save_amount) {
      var savePrice = '';
      if (boostPFSConfig.custom.product_save_type == 'dollar') {
        savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
      } else {
        savePrice = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min);
        savePrice += '%';
      }
      var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);;
      itemPriceHtml += '<span class="grid-product__price--savings">' + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add label
    var customLabel = '';
    data.tags.forEach(function(tag) {
      if (tag.startsWith('_label_')) {
        if (!customLabel) {
          customLabel = tag.replace('_label_', '');
        }
      }
    });
    var itemLabelHtml = '';
    if (customLabel) {
      itemLabelHtml = '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + '</div>';
    } else {
      // soldOut Label
      if (soldOut) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSConfig.label.sold_out + '</div>';
      } else if (onSale) {
        /* Start-Boost-168319 */
        var percentSale = data.hasOwnProperty('percent_sale_min') ? data.percent_sale_min : (Math.round((data.compare_at_price - data.price) * 100 / data.compare_at_price));
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sale">-' + percentSale + '%</div>';
        /* End-Boost-168319 */
      }
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Quick shop
    var itemQuickShopClass = '';
    var itemQuickShopButtonHtml = '';
    if (boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopClass = 'grid-product__has-quick-shop';
      itemQuickShopButtonHtml = '<div class="quick-product__btn quick-product__btn--not-ready js-modal-open-quick-modal-{{itemId}} small--hide ' + (isFirstLoad ? '' : 'bc-hide') + '" data-product-id="{{itemId}}"' + quickViewTrackingAttr + '>' +
        '<span class="quick-product__label">' + boostPFSConfig.label.quick_shop + '</span>' +
        '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
    itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      var reviewHtml = '';
      if(boostPFSConfig.custom.enable_product_reviews) {
        reviewHtml = '<span class="shopify-product-reviews-badge" data-id="'+ data.id +'"></span>';
      }
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewHtml);
    }

    // Color swatch
    var swatchHtml = buildSwatch(data, this);
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
    itemHtml = itemHtml.replace(/{{itemSwatchHoverImages}}/g, swatchHtml.itemSwatchHoverImages);

    var itemQuickShopModal = '';

    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopModal = '<div id="QuickShopModal-{{itemId}}" class="modal modal--square modal--quick-shop" data-product-id="{{itemId}}">' +
        '<div class="modal__inner">' +
          '<div class="modal__centered">' +
            '<div class="modal__centered-content">' +
              '<div id="QuickShopHolder-{{itemHandle}}"></div>' +
            '</div>' +

            '<button type="button" class="modal__close js-modal-close text-link">' +
              '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg>' +
              '<span class="icon__fallback-text">Close Modal</span>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopModal}}/g, itemQuickShopModal);

    /* Start-Boost-168319 */
    /* Swym integration */
    var itemWishlistHtml =
      '<button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product wishlist swym-button product_' + data.id + '"' +
      ' data-swaction="addToWishlist"' +
      ' data-product-id="' + JSON.stringify(data.id) + '"' +
      ' data-variant-id="' + data.variants[0].id + '"' +
      ' data-product-url="' + boostPFSConfig.shop.url + baseProductUrl + '"' +
      wishlistTrackingAttr +
      '></button>';

    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

    //var itemWishlistHtml = '<a data-with-epi="true" class="wishlist_item product_' + data.id + ' product_wishlist_item" data-swaction="addToWishlist" data-product-id="' + JSON.stringify(data.id) + '" data-variant-id="' + data.variants[0].id + '" data-product-url="' + boostPFSConfig.shop.url + Utils.buildProductItemUrl(data, false) + '"><div id="wishlist-container" class="wishlist-icon"></div> </a>';
    //itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

    /* Custom badges */
    var new_in = '';
    var best_seller = '';
    var custom_badge = '';
    for (var i = 0; i < data.tags.length; i++) {
      var tag = data.tags[i].toLowerCase();
      if (tag == 'badge_new in') {
        new_in = tag.replace('badge_', '');
      } else if (tag == 'badge_best seller') {
        best_seller = tag.replace('badge_', '');
      } else if (tag.indexOf('badge_') !== -1) {
        custom_badge = tag.replace('badge_', '');
      }
    }
    var itemCustomBadges = '';
    itemCustomBadges += '<div class="jsc-badge uppercase fontSize-xs color-grey m-b-10">';
    if (new_in !== '') {
      itemCustomBadges += new_in;
    } else if (best_seller !== '') {
      itemCustomBadges += best_seller;
    } else if (custom_badge !== '') {
      itemCustomBadges += custom_badge;
    }
    itemCustomBadges += '</div>';
    itemHtml = itemHtml.replace(/{{itemCustomBadges}}/g, itemCustomBadges);
    /* End-Boost-168319 */

    var metafields = data.metafields;
    var itemCustomImage = '';
    metafields.forEach(function (metafield, index) {
      if (metafield.key == 'techwork_icons' && metafield.namespace == "custom") {
        console.log('###metafields:', metafields)
        var metafield_values = JSON.parse(metafield.value);
        if (metafield_values.length > 0){
          for (let index = 0; index < metafield_values.length; index++) {
            if (index == 4) {
              break
            }
            const formated_id = metafield_values[index].replace('gid://shopify/Metaobject/', '');
            console.log('###formated_id:', formated_id);
            itemCustomImage += `<img src="${window.techwork_icons[formated_id].image}" alt="${window.techwork_icons[formated_id].title}" width="48" height="auto">`
          }
        }
      }
    });
    var itemCustomImageHTML = '';
    if (itemCustomImage != '') {
      itemCustomImageHTML = `<div class="jsc-image-badge" data-template="collection">${itemCustomImage}</div>`
    }
    console.log(itemCustomImageHTML)
    itemHtml = itemHtml.replace(/{{itemCustomImage}}/g, itemCustomImageHTML);
    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, trackTitle);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, productUrl);
    itemHtml = itemHtml.replace(/{{itemProductTracking}}/g, productTrackingAttr);

    return itemHtml;
  };

  // Build Swatch
  function buildSwatch(data, _this) {
    var itemSwatchHtml = '';
    var itemSwatchHoverImagesHtml = '';
    if (boostPFSConfig.custom.collection_color_swatches) {
      var swatchItems = [];
      var swatchHoverImages = [];
      data.options_with_values.forEach(function(option, index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1) {
          var option_index = index;
          var values = [];
          data.variants.forEach(function(variant) {
            var value = variant.merged_options[option_index].split(':')[1];
            if (values.indexOf(value) == -1) {
              values.push(value);
              var colorValueSlugify = Utils.slugify(value);
              var colorImage = Utils.optimizeImage(boostPFSAppConfig.general.file_url.replace('/?', '/' + colorValueSlugify + '.png?'), '50x');
              var variantImage = Utils.optimizeImage(variant.image, '400x');

              var swatchItem = '<a href="{{itemUrl}}?variant={{variantId}}" ' +
                'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
                'data-variant-id="{{variantId}}" ' +
                'data-variant-image="{{variantImage}}" ' +
                'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                '</a>';

              swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
              swatchItem = swatchItem.replace(/{{colorValueSlugify}}/g, colorValueSlugify);
              swatchItem = swatchItem.replace(/{{swatchClass}}/g, variant.image ? 'color-swatch--with-image' : '');
              swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
              swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
              swatchItem = swatchItem.replace(/{{backgroundColor}}/g, colorValueSlugify.split('-').pop());

              var swatchHoverImage = '<div class="grid-product__color-image grid-product__color-image--' + variant.id + ' small--hide"></div>';

              swatchItems.push(swatchItem);
              swatchHoverImages.push(swatchHoverImage);
            }
          });
        }
      });
      if (swatchItems.length > 1) {
        itemSwatchHtml = ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' + swatchItems.join('') + '</div>';
        itemSwatchHoverImagesHtml = swatchHoverImages.join('');
      }
    }
    return {
      itemSwatch: itemSwatchHtml,
      itemSwatchHoverImages: itemSwatchHoverImagesHtml
    };
  }

  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    var paginationHtml = '';
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {

      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
    return '';
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = boostPFSTemplate.sortingHtml;
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Utils.stripHtml(Globals.queryParams.sort) || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          activeClass = '';
          if (paramSort == k) {
            activeClass = 'boost-pfs-filter-sort-item-active';
          }
          sortingItemsHtml += '<li aria-label="' + sortingArr[k] + '"><a href="#" data-sort="' + k + '" class="' + activeClass + '"  title="' + sortingArr[k] + '" aria-label="' + sortingArr[k] + '">' + sortingArr[k] + '</a></li>';
        }
        html = html.replace(/{{sortingItems}}/g, sortingItemsHtml);
        html = html.replace(/{{sortingLabel}}/g, Labels.sorting);
      }
    }
    return html;
  };
  
  ProductSorting.prototype.render = function() {
    jQ(Selector.topSorting).html(this.compileTemplate());
  
    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }
  
    var labelSort = '';
    var paramSort = Utils.stripHtml(Globals.queryParams.sort) || '';
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting_heading;
    }
  
    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  }
  
  // Build Sorting event
  ProductSorting.prototype.bindEvents = function() {
    var _this = this;
    jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).data('sort'));
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });

    if (Utils.isMobile()) {
      jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
        jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
      });
    } else {
      jQ(".boost-pfs-filter-custom-sorting > button").off('mouseleave').on('mouseleave', function(e) {
        jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
        if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').hasClass('boost-pfs-filter-sort-active')) {
          jQ('.boost-pfs-filter-filter-dropdown').show();
        } else {
          jQ('.boost-pfs-filter-filter-dropdown').hide();
        }
      });
  
      jQ(".boost-pfs-filter-custom-sorting > button").off('mouseover').on('mouseover', function(e) {
        jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
        if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').hasClass('boost-pfs-filter-sort-active')) {
          jQ('.boost-pfs-filter-filter-dropdown').show();
        } else {
          jQ('.boost-pfs-filter-filter-dropdown').hide();
        }
      });
    }
    jQ(Selector.filterTreeMobileButton).click(function() {
      jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
    });
  
    jQ(document).on('click', function (e) {
      if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').find(".boost-pfs-filter-filter-dropdown").length === 0) {
        jQ('.boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
      }
    });
  };

  /* buildExtraProductList */
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;

    // Hover color swatch
    onColorSwatchHover();

    // update related product swatches 
    for (var product of data) {
      swatches(product);
    }
    
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  };

 /* Boost 172510 */
  function swatches(data) {
    var swatchData = [];
    var itemSwatchHtml = '';
    var swatch = Utils.getProductMetafield(data,'swatch','product');
    var swatchIds = JSON.parse(swatch);
    var isLast = 0;
    if (swatch) {
      for (var itemGid of swatchIds) {
            var itemGid = itemGid.replace(/[:/]/g,'').toLowerCase();
            fetch(`https://services.mybcapps.com/bc-sf-filter/search?q=${itemGid}&_=pf&shop=g2000th.myshopify.com&locale=${Shopify.locale}&sid=c81b238e-1965-4826-aecc-c95c8ea946b1`,{method: 'GET'})
            .then(response => response.json())
            .then(function(fetchData) {
              if (fetchData.products.length > 0 && fetchData.products[0].id !== data.id) {
                swatchData.push(fetchData.products[0])
              }
              isLast = isLast + 1;
            })
          }
      
      var interId = setInterval(function () {
        if (isLast === swatchIds.length) {
          itemSwatchHtml += `<div class="pfs-swatch--container"
                                style="display: flex;
                                flex-wrap: wrap;
                            ">`;
          itemSwatchHtml += swatchHtml(data);
         
          for (itemSwatch of swatchData) {
            itemSwatchHtml += swatchHtml(itemSwatch);
          }
          itemSwatchHtml += '</div>';
          jQ('.boost-pfs-filter-products [data-product-id="' + data.id + '"] .grid-product__meta').append(itemSwatchHtml);
          clearInterval(interId);
        }
      }, 30)
      setTimeout(function (params) {
        clearInterval(interId)
      },3000)
    } else {
          itemSwatchHtml += `<div class="pfs-swatch--container"
                                style="display: flex;
                                flex-wrap: wrap;
                            ">`;
          itemSwatchHtml += swatchHtml(data);
          itemSwatchHtml += '</div>';
          jQ('.boost-pfs-filter-products [data-product-id="' + data.id + '"] .grid-product__meta').append(itemSwatchHtml);
    }
  }
  function swatchHtml(data) {
    var html = '';
    var colorOption = data.options_with_values.find(e => e.name === 'color');
    if (colorOption) {
      var color = colorOption['values'][0]['title'].toLowerCase();
      if (color.split(' ').length === 2 ){
        color = color.split(' ')[1];
      }

      html += `<a href="${Utils.buildProductItemUrlWithVariant(data)}" 
                  class="color-swatch color-swatch--small color-swatch--blue " 
                  data-variant-id="${data.variants[0]['id']}" 
                  data-variant-image="${data.images_info[0]['src']}" 
                  style="background-image: url(//cdn.shopify.com/s/files/1/0706/4417/1049/files/${color}_50x.png?5078); 
                  background-color: ${color};"> 
               </a>`;
    }
    return html;
  }
 /* End Boost 172510 */
  
  function onColorSwatchHover() {
    document.querySelectorAll('.color-swatch--with-image').forEach(swatch => {
      swatch.addEventListener('mouseenter', function() {
        var id = swatch.dataset.variantId;
        var image = swatch.dataset.variantImage;
        var el = document.querySelector('.grid-product__color-image--' + id);
        el.style.backgroundImage = 'url(' + image + ')';
        el.classList.add('is-active');
      });
      swatch.addEventListener('mouseleave', function() {
        var id = swatch.dataset.variantId;
        document.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
      });
    });
  }

  /* buildAdditionalElements */
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;

    // Call theme init function
    //wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
    jQ(document).ready(function() {
      if (typeof theme !== null && window.theme) {
        if(typeof AOS != 'undefined' && typeof AOS.refreshHard == 'function'){
          AOS.refreshHard();
        }
        // Setup page transition classes
        if (typeof theme.pageTransitions == 'function') {
          theme.pageTransitions();
        }

        // Quickview button: Use boost otp & otp style 3, disable add to cart

        // // Reload products inside each quick shop
        // if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
        if (window.$ && typeof $ == 'function') {
          $(window).off('popstate');
        }
      }

      if (isFirstLoad) {
        isFirstLoad = false;
      }

      // jQ('.js-drawer-open-collection-filters').on('click', function() {
      //   jQ('.' + Class.filterOption).each(function() {
      //     var showMoreType = jQ(this).data('show-more-type');
      //     if (showMoreType && jQ(this).data('display-type') != 'range') {
      //       self.buildFilterShowMore(jQ(this).find('.' + Class.filterBlockContent), showMoreType);
      //     }
      //   });
      // });
    });
    // Add modal container for quickview
    var isReinitQuickview = !isFirstLoad || Utils.isSearchPage() || Globals.queryParams.hasOwnProperty('_');
    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable && isReinitQuickview) {
      jQ('.boost-pfs-quick-shop-modal-container').html('');
      if (data.products.length > 0) {
        data.products.forEach(function(product){
          var quickUrl = Utils.buildProductItemUrl(product) + '?view=boost-pfs-quickview';
          jQ.ajax({url: quickUrl, success: function(result) {
            numberQuickViewModalLoaded++;
            jQ('.boost-pfs-quick-shop-modal-container').append(result);
            if (numberQuickViewModalLoaded == data.products.length) {
              theme.collapsibles.init();
              numberQuickViewModalLoaded = 0;
              jQ('.quick-product__btn').removeClass('bc-hide');
            }
          }});
        });
      }
    }

    // Build total products text
    var totalProductText = '';
    if (data.total_product == 1) {
      totalProductText = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
    } else {
      totalProductText = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
    }
    jQ('.boost-pfs-filter-total-product').html(totalProductText);

    // Build filter button text on mobile
    // var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
    // if (numSelectedFilter) {
    //   jQ('.js-drawer-open-collection-filters').addClass('btn--tertiary-active');
    //   jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
    // } else {
    //   jQ('.js-drawer-open-collection-filters').removeClass('btn--tertiary-active');
    //   jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter);
    // }
    theme.initQuickShop();
  };

  FilterTree.prototype.afterRender = function() {
    if (Utils.isMobile()) {
      var count = 0;
    
      this.filterOptions.forEach(function(filterOption) {
          count += filterOption.numberAppliedFilterItems;
      })
      
      // We prepend the count number above the filter tree
      if (count > 0) {
        this.$element.find('.boost-pfs-filter-count').remove();
        if (count == 1) {
          this.$element.find(this.selector.filterFooter).prepend('<div class="boost-pfs-filter-count">' + count + ' filter selected</div>');
        } else {
          this.$element.find(this.selector.filterFooter).prepend('<div class="boost-pfs-filter-count">' + count + ' filters selected</div>');
        }
      }
    }
    
  }
})();